export const FEATURE_KEYS = [
  'outreach',
  'hubspot',
  'hubspotCustom',
  'fourMativ',
  'numbersPool',
  'accountSettings',
  'callerId',
  'contactsFilter',
  'userSettings',
  'dashboardDetails',
  'callRecordings',
  'salesforce',
  'calendly',
  'aiScripts',
  'newUI',
  'recordingExclusions'
] as const;

export type OrganizationFeatureKey = typeof FEATURE_KEYS[number];

export type FeaturesDto = Record<OrganizationFeatureKey, boolean>;

export interface FeatureFlagsServerResponse extends FeaturesDto {
  id: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: unknown;
}

export const DEFAULT_FLAGS: FeaturesDto = (() => {
  const entries = FEATURE_KEYS.map((k) => [k, false] as const);
  const base = Object.fromEntries(entries) as FeaturesDto;

  base.userSettings = true;
  base.accountSettings = true;
  base.numbersPool = true;
  base.callerId = true;
  base.dashboardDetails = true;
  base.newUI = true;

  return base;
})();

export const FEATURE_LABELS: Record<OrganizationFeatureKey, string> = {
  outreach: 'Outreach',
  hubspot: 'HubSpot',
  hubspotCustom: 'HubSpot Custom',
  fourMativ: 'FourMativ',
  numbersPool: 'Numbers Pool',
  accountSettings: 'Account Settings',
  callerId: 'Caller ID',
  contactsFilter: 'Contacts Filter',
  userSettings: 'User Settings',
  dashboardDetails: 'Dashboard Details',
  callRecordings: 'Call Recordings',
  salesforce: 'Salesforce',
  calendly: 'Calendly',
  aiScripts: 'AI Scripts',
  newUI: 'New UI',
  recordingExclusions: 'Recordings Exclusions'
};

export function applyFeatureDependencies<T extends Partial<FeaturesDto>> (flags: T): T {
  const result = { ...flags };
  if (result.recordingExclusions === true && result.callRecordings === false) {
    result.recordingExclusions = false;
  }
  return result;
}

export interface ActiveOrganizationsResponse { id: string; name: string; }

export interface OrganizationManagement {
  id: string;
  _id?: string;
  name: string;
  organizationName?: string;
  adminsId?: string[];
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateOrganizationDto {
  name: string;
  adminsId?: string[];
  isActive?: boolean;
}

export interface UpdateOrganizationDto extends CreateOrganizationDto {
  id?: string;
  _id?: string;
}

export type OrgRow = OrganizationManagement & { featureBadges: string[] };

export type UpdateFeatureFlagsDto = Partial<FeaturesDto>;
